import request from '@/utils/request'

// 赛事介绍
export function getcompetition(params){
    return request({
        url: "/api/competitions/getcompetition",
        method: 'get',
        params   
    })
}